export default {
  slogan: 'Nous pigeons. Vous pigez. Tout le monde pige.',
  ctaTitle: ' Ne restez pas dans l’entrée, venez! ',
  ctaSubtitle:
    'Il y a plein, plein, plein d’avantages à faire partie de Pigeons — autant pour les pigistes que les recruteur·euse·s. Mais pour en profiter, il faut d’abord s’inscrire. (En plus, ça ne coûte rien !).',
  discoverButton: 'Découvrir Pigeons.',
  hero: {
    title: 'Trouvez le freelance marketing parfait pour votre projet.',
    subtitle:
      'Connectez-vous avec les meilleurs professionnels du marketing, formez des équipes puissantes et donnez vie à vos projets.',
    getStarted: 'Commencer',
    browse: 'Parcourir les freelances.',
  },
  features: {
    title: 'Pourquoi nous choisir.',
    subtitle: 'Tout ce dont vous avez besoin pour trouver ou offrir des services marketing.',
    smartMatching: {
      title: 'Matching Intelligent.',
      description:
        "Notre système alimenté par l'IA vous met en relation avec les freelances parfaits selon vos besoins.",
    },
    teamFormation: {
      title: "Formation d'Équipe.",
      description:
        "Formez des alliances puissantes avec d'autres freelances pour gérer efficacement des projets plus importants.",
    },
    securePayments: {
      title: 'Paiements Sécurisés.',
      description:
        "Profitez d'un traitement sécurisé des paiements et d'une facturation facile pour tous vos projets.",
    },
  },
};
